// extracted by mini-css-extract-plugin
module.exports = {"noSearchResults":"search-empty-state_noSearchResults__7pOZn","title":"search-empty-state_title__bx_44","searchTerm":"search-empty-state_searchTerm___yZv3"};